




















import VModal from "@/components/VModal.vue";
import { Component, Vue, Ref } from "vue-property-decorator";

@Component({ components: { VModal } })
export default class WrongExcelModal extends Vue {
  @Ref() readonly main!: VModal;
  show() {
    this.main.show();
  }
  onClose() {
    this.main.hide();
  }
}
